module.exports = __webpack_public_path__ + "static/sjova-3-1b9346227e05ff406d2905b8ba27ff5f.jpg";